// extracted by mini-css-extract-plugin
export default {"zoomModal":"P3-z"};